import { PropTypes } from "prop-types"
import Select from "react-select"
import AsyncSelect from "react-select/async"
import _ from "lodash"

export const InputSelect = ({
  disabled,
  id,
  isClearable,
  options,
  onChange,
  saveObjectAsValue,
  selectedValue = "",
  type = "FIXED",
  ...rest
}) => {
  const SelectComponent = type === "ASYNC" ? AsyncSelect : Select
  const handleChange = option => {
    if (saveObjectAsValue) {
      onChange(option || "")
    } else {
      onChange(option ? option.value : "")
    }
  }

  return (
    <SelectComponent
      classNamePrefix="react-select"
      options={options}
      inputId={id}
      isClearable={isClearable || type !== "FIXED"}
      isDisabled={disabled}
      isSearchable={type !== "FIXED"}
      onChange={handleChange}
      getOptionLabel={option => {
        if (typeof option.label === "string") {
          return `${option.label}`
        }
        if (
          typeof option.label === "object" &&
          typeof Object.values(option.label)[0] === "string"
        ) {
          return `${Object.values(option.label)[0]} ${Object.values(option.label)[1]}`
        }
        return option.value
      }}
      {...rest}
      value={
        options
          ? options.filter(
              option => _.isEqual(option, selectedValue) || _.isEqual(option.value, selectedValue)
            )
          : !_.isEmpty(selectedValue) && { value: selectedValue }
      }
    />
  )
}

InputSelect.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isClearable: PropTypes.bool,
  label: PropTypes.node,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      label: PropTypes.any,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
    })
  ),
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  type: PropTypes.oneOf(["FIXED", "SEARCHABLE", "ASYNC"]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  saveObjectAsValue: PropTypes.bool
}

InputSelect.displayName = "InputSelect"

export default InputSelect
